'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

// export const languages: { [iso2: string]: LangItem } = {
//   en: {
//     iso2: 'en',
//     iso3: 'eng',
//     name: 'English',
//   },
//   th: {
//     iso2: 'th',
//     iso3: 'tha',
//     name: 'Thai',
//   },
//   he: {
//     iso2: 'he',
//     iso3: 'heb',
//     name: 'Hebrew',
//   },
//   ch: {
//     iso2: 'ch',
//     iso3: 'chn',
//     name: 'China',
//   },
//   jp: {
//     iso2: 'jp',
//     iso3: 'jpn',
//     name: 'Japanese',
//   },
//
// };
var languages = [
    {
        'name': 'Algerian Spoken Arabic',
        'iso2': '',
        'iso3': 'arq',
    },
    {
        'name': 'Amharic',
        'iso2': 'am',
        'iso3': 'amh',
    },
    {
        'name': 'Arabic',
        'iso2': 'ar',
        'iso3': 'ara',
    },
    {
        'name': 'Assamese',
        'iso2': 'as',
        'iso3': 'asm',
    },
    {
        'name': 'Azerbaijani',
        'iso2': 'az',
        'iso3': 'aze',
    },
    {
        'name': 'Baluchi',
        'iso2': '',
        'iso3': 'bal',
    },
    {
        'name': 'Bengali',
        'iso2': 'bn',
        'iso3': 'ben',
    },
    {
        'name': 'Bhojpuri',
        'iso2': '',
        'iso3': 'bho',
    },
    {
        'name': 'Burmese',
        'iso2': 'my',
        'iso3': 'mya',
    },
    {
        'name': 'Cebuano',
        'iso2': '',
        'iso3': 'ceb',
    },
    {
        'name': 'Chhattisgarhi',
        'iso2': '',
        'iso3': 'hne',
    },
    {
        'name': 'Chinese',
        'iso2': 'zh',
        'iso3': 'zho',
    },
    {
        'name': 'Chittagonian',
        'iso2': '',
        'iso3': 'ctg',
    },
    {
        'name': 'Czech',
        'iso2': 'cs',
        'iso3': 'ces',
    },
    {
        'name': 'Deccan',
        'iso2': '',
        'iso3': 'dcc',
    },
    {
        'name': 'Dutch',
        'iso2': 'nl',
        'iso3': 'nld',
    },
    {
        'name': 'Eastern Punjabi',
        'iso2': 'pa',
        'iso3': 'pan',
    },
    {
        'name': 'Egyptian',
        'iso2': '',
        'iso3': 'egy',
    },
    {
        'name': 'French',
        'iso2': 'fr',
        'iso3': 'fra',
    },
    {
        'name': 'Fulah',
        'iso2': 'ff',
        'iso3': 'ful',
    },
    {
        'name': 'Gan',
        'iso2': '',
        'iso3': 'gan',
    },
    {
        'name': 'German',
        'iso2': 'de',
        'iso3': 'deu',
    },
    {
        'name': 'Greek',
        'iso2': 'el',
        'iso3': 'ell',
    },
    {
        'name': 'Gujarati',
        'iso2': 'gu',
        'iso3': 'guj',
    },
    {
        'name': 'Hakka',
        'iso2': '',
        'iso3': 'hak',
    },
    {
        'name': 'Hijazi Spoken Arabic',
        'iso2': '',
        'iso3': 'acw',
    },
    {
        'name': 'Hindi',
        'iso2': 'hi',
        'iso3': 'hin',
    },
    {
        'name': 'Hungarian',
        'iso2': 'hu',
        'iso3': 'hun',
    },
    {
        'name': 'Igbo',
        'iso2': 'ig',
        'iso3': 'ibo',
    },
    {
        'name': 'Indonesian',
        'iso2': 'id',
        'iso3': 'ind',
    },
    {
        'name': 'Italian',
        'iso2': 'it',
        'iso3': 'ita',
    },
    {
        'name': 'Japanese',
        'iso2': 'ja',
        'iso3': 'jpn',
    },
    {
        'name': 'Kannada',
        'iso2': 'kn',
        'iso3': 'kan',
    },
    {
        'name': 'Kazakh',
        'iso2': 'kaz',
        'iso3': 'kk',
    },
    {
        'name': 'Khmer',
        'iso2': 'km',
        'iso3': 'khm',
    },
    {
        'name': 'Kinyarwanda',
        'iso2': 'rw',
        'iso3': 'kin',
    },
    {
        'name': 'Korean',
        'iso2': 'ko',
        'iso3': 'kor',
    },
    {
        'name': 'Kurdish',
        'iso2': 'ku',
        'iso3': 'kur',
    },
    {
        'name': 'Lahnda',
        'iso2': '',
        'iso3': 'lah',
    },
    {
        'name': 'Magahi',
        'iso2': '',
        'iso3': 'mag',
    },
    {
        'name': 'Maithili',
        'iso2': '',
        'iso3': 'mai',
    },
    {
        'name': 'Malagasy',
        'iso2': 'mg',
        'iso3': 'mlg',
    },
    {
        'name': 'Malay',
        'iso2': 'ms',
        'iso3': 'msa',
    },
    {
        'name': 'Malayalam',
        'iso2': 'ml',
        'iso3': 'mal',
    },
    {
        'name': 'Mandarin',
        'iso2': '',
        'iso3': 'cmn',
    },
    {
        'name': 'Marathi',
        'iso2': 'mr',
        'iso3': 'mar',
    },
    {
        'name': 'Marwari',
        'iso2': '',
        'iso3': 'mwr',
    },
    {
        'name': 'Mesopotamian Spoken Arabic',
        'iso2': '',
        'iso3': 'acm',
    },
    {
        'name': 'Min Bei Chinese',
        'iso2': '',
        'iso3': 'mnp',
    },
    {
        'name': 'Min Dong Chinese',
        'translation': 'Min Dong Chinese',
        'iso2': '',
        'iso3': 'cdo',
    },
    {
        'name': 'Moroccan Spoken Arabic',
        'iso2': '',
        'iso3': 'ary',
    },
    {
        'name': 'Nepali',
        'iso2': 'ne',
        'iso3': 'nep',
    },
    {
        'name': 'Nigerian Fulfulde',
        'translation': 'Nigerian Fulfulde',
        'iso2': '',
        'iso3': 'fuv',
    },
    {
        'name': 'North Levantine Spoken Arabic',
        'iso2': '',
        'iso3': 'apc',
    },
    {
        'name': 'Northern Kurdish',
        'iso2': '',
        'iso3': 'kmr',
    },
    {
        'name': 'Northern Pashto',
        'iso2': '',
        'iso3': 'pbu',
    },
    {
        'name': 'Northern Uzbek',
        'iso2': '',
        'iso3': 'uzn',
    },
    {
        'name': 'Odia',
        'iso2': '',
        'iso3': 'ory',
    },
    {
        'name': 'Oriya',
        'iso2': '',
        'iso3': 'ory',
    },
    {
        'name': 'Oromo',
        'iso2': 'om',
        'iso3': 'orm',
    },
    {
        'name': 'Pashto',
        'iso2': 'ps',
        'iso3': 'pus',
    },
    {
        'name': 'Persian',
        'iso2': 'fa',
        'iso3': 'fas',
    },
    {
        'name': 'Polish',
        'iso2': 'pl',
        'iso3': 'pol',
    },
    {
        'name': 'Portuguese',
        'iso2': 'pt',
        'iso3': 'por',
    },
    {
        'name': 'Romanian',
        'iso2': '',
        'iso3': 'rms',
    },
    {
        'name': 'Rundi',
        'iso2': 'rn',
        'iso3': 'run',
    },
    {
        'name': 'Russian',
        'iso2': 'ru',
        'iso3': 'rus',
    },
    {
        'name': 'Saʽidi Spoken Arabic',
        'translation': 'Saʽidi Spoken Arabic',
        'iso2': '',
        'iso3': 'aec',
    },
    {
        'name': 'Sanaani Spoken Arabic',
        'translation': 'Sanaani Spoken Arabic',
        'iso2': '',
        'iso3': 'ayn',
    },
    {
        'name': 'Saraiki',
        'iso2': '',
        'iso3': 'skr',
    },
    {
        'name': 'Serbo-Croatian',
        'iso2': 'sh',
        'iso3': 'hbs',
    },
    {
        'name': 'Sindhi',
        'iso2': 'sd',
        'iso3': 'snd',
    },
    {
        'name': 'Sinhala',
        'iso2': 'si',
        'iso3': 'sin',
    },
    {
        'name': 'Somali',
        'iso2': 'so',
        'iso3': 'som',
    },
    {
        'name': 'South Azerbaijani',
        'iso2': '',
        'iso3': 'azb',
    },
    {
        'name': 'South Levantine Spoken Arabic',
        'iso2': '',
        'iso3': 'ajp',
    },
    {
        'name': 'Southern Pashto',
        'iso2': '',
        'iso3': 'pbt',
    },
    {
        'name': 'Spanish',
        'iso2': 'es',
        'iso3': 'spa',
    },
    {
        'name': 'Sudanese Spoken Arabic',
        'iso2': '',
        'iso3': 'apd',
    },
    {
        'name': 'Sunda',
        'iso2': 'su',
        'iso3': 'sun',
    },
    {
        'name': 'Sylheti',
        'iso2': '',
        'iso3': 'syl',
    },
    {
        'name': 'Tagalog',
        'iso2': 'tl',
        'iso3': 'tgl',
    },
    {
        'name': 'Taʽizzi-Adeni Spoken Arabic',
        'translation': 'Taʽizzi-Adeni Spoken Arabic',
        'iso2': '',
        'iso3': 'acq',
    },
    {
        'name': 'Tamil',
        'iso2': 'ta',
        'iso3': 'tam',
    },
    {
        'name': 'Telugu',
        'iso2': 'te',
        'iso3': 'tel',
    },
    {
        'name': 'Thai',
        'iso2': 'th',
        'iso3': 'tha',
    },
    {
        'name': 'Tunisian Spoken Arabic',
        'iso2': '',
        'iso3': 'aeb',
    },
    {
        'name': 'Turkish',
        'iso2': 'tr',
        'iso3': 'tur',
    },
    {
        'name': 'Ukrainian',
        'iso2': 'uk',
        'iso3': 'ukr',
    },
    {
        'name': 'Uyghur',
        'iso2': 'ug',
        'iso3': 'uig',
    },
    {
        'name': 'Uzbek',
        'iso2': 'uzb',
        'iso3': 'uz',
    },
    {
        'name': 'Vietnamese',
        'iso2': 'vi',
        'iso3': 'vie',
    },
    {
        'name': 'Western Punjabi',
        'iso2': 'pa',
        'iso3': 'pan',
    },
    {
        'name': 'Xiang Chinese',
        'translation': 'Xiang Chinese',
        'iso2': '',
        'iso3': 'hsn',
    },
    {
        'name': 'Yoruba',
        'iso2': 'yo',
        'iso3': 'yor',
    },
    {
        'name': 'Zhuang',
        'iso2': 'za',
        'iso3': 'zha',
    },
    {
        'name': 'Zulu',
        'iso2': 'zu',
        'iso3': 'zul',
    },
    {
        'name': 'English',
        'iso2': 'en',
        'iso3': 'eng',
    },
];

exports.languages = languages;
